import { useTheme } from '../context/ThemeContext';
import MobileAppSection from '../components/DetailedServices/MobileAppSection';

export default function MobileAppPage() {
  const { theme } = useTheme();
  
  return (
    <div className={`pt-16 ${theme === 'dark' ? 'bg-black' : 'bg-white'}`}>
      <MobileAppSection />
    </div>
  );
}